<template>
  <div class="adp-all-box">
    <!--    整体背景-->
    <img src="../../img/dpsj/bg.png" alt="" class="adp-all-bg-img">

    <!--    返回按钮-->
    <!--    <div class="adp-back-button-box" @click="adpGoBack()">-->
    <!--      <img src="../../img/lBackButton.png" alt="" style = "width: 155px;height: 40px">-->
    <!--      <div class="adp-back-text-box">-->
    <!--        返回-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    公司名称-->
    <div class="adp-conpany-name">
      {{EnterPrise.cEntName}}
    </div>

    <!--    返回按钮-->
    <div class="adp-back-box" @click="adpGoBack()">
      <a-icon type="arrow-left" style="font-size: 130%;margin-right: 3px" />
      <span>回上页</span>
    </div>

    <!--    全屏按钮-->
    <div class="adp-qp-box" @click="getFullCreeen">
      <a-icon type="retweet" style="font-size: 130%;margin-right: 3px" />
      <span v-show='n%2==0'>全屏</span>
      <span v-show='n%2!==0'>返回</span>
    </div>

    <!--    视频模块-->
    <div class="adp-video-all-box">
      <img src="../../img/dpsj/spwk.png" alt="" class="adp-mod-bg-img">

      <div class="adp-video-content-box">

        <div class="adp-video-title-box">
          <img src="../../img/dpsj/titleIcon.png" alt="" class="adp-title-icon">
          设备名称：{{videodata.cDeviceAsName}}
        </div>

        <div class="adp-video-box">
          <videoPlayer ref="videoPlayer" :options="videoOptions" class="vjs-custom-skin videoPlayer" :playsinline="true" />
        </div>

      </div>
    </div>

    <!--    天气模块-->
    <div class='adp-weather-all-box'>
      <img src="../../img/dpsj/tqwk.png" alt="" class="adp-mod-bg-img">

      <div class="adp-weather-title">
        <img src="../../img/dpsj/titleIcon.png" alt="" class="adp-title-icon">
        气象数据
      </div>

      <div class="adp-weather-today-box">
        <img :src="this.weatherToday.iconSrc" alt="" width="30px">
        <div><span style="font-size: 190%">{{weatherToday.tmp.max}}</span>℃ </div>
        <div>{{weatherToday.tmp.min}}~{{weatherToday.tmp.max}} ℃</div>
        <div>{{weatherToday.wind.dir}}</div>
        <a-tag color="#0059d0" style="padding: 0 24px">
          {{weatherToday.cond.txt_d}}
        </a-tag>
      </div>

      <div class="adp-wo-all-box">

        <div class="adp-wo-single-box" v-for="item in weatherOtherDay">
          <div>{{item.wind.dir}}</div>
          <div class="adp-wo-date">{{item.date}}</div>
          <img :src="item.iconSrc" alt="" width="25px">
          <div>{{item.tmp.min}}~{{item.tmp.max}} ℃</div>

          <a-tag color="#0059d0" style="padding: 0 16px">
            {{item.cond.txt_d}}
          </a-tag>

        </div>
        <!--        <div class="adp-wo-single-box">-->
        <!--          <div>周三</div>-->
        <!--          <div class="adp-wo-date">8月25日</div>-->
        <!--          <img src="../../img/dpsj/sun.png" alt=""  width="25px">-->
        <!--          <div>21~31 ℃</div>-->
        <!--          <div>西南风微风</div>-->
        <!--          <a-tag color="#0059d0" style="padding: 0 16px">-->
        <!--            良-->
        <!--          </a-tag>-->
        <!--        </div>-->
        <!--        <div class="adp-wo-single-box">-->
        <!--          <div>周四</div>-->
        <!--          <div class="adp-wo-date">8月25日</div>-->
        <!--          <img src="../../img/dpsj/sun.png" alt=""  width="25px">-->
        <!--          <div>21~31 ℃</div>-->
        <!--          <div>西南风微风</div>-->
        <!--          <a-tag color="#0059d0" style="padding: 0 16px">-->
        <!--            良-->
        <!--          </a-tag>-->
        <!--        </div>-->

      </div>

    </div>

    <!--    公司简介模块-->
    <div class="adp-company-all-box">
      <img src="../../img/dpsj/gsjj.png" alt="" class="adp-mod-bg-img">

      <div class="adp-company-title">
        <img src="../../img/dpsj/titleIcon.png" alt="" class="adp-title-icon">
        公司简介
      </div>

      <div class="adp-company-content">
        {{EnterPrise.cProduce}}
      </div>
    </div>
    <div class="adp-tb-all-box2">
      <img src="../../img/dpsj/tbwk.png" alt="" class="adp-mod-bg-img">
      <div class="adp-tb-bing-box2" ref="chartTwo" id="chartTwo">

      </div>
    </div>

    <!--    场地数据模块-->
    <div class="adp-scene-all-box">
      <img src="../../img/dpsj/cjwk.png" alt="" class="adp-mod-bg-img">
      <div class="adp-scene-choose-box">

        <a-dropdown class="header-right-icon-text" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; margin: 0 5px 0 5px">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()" style="width: 150px;     display: block;    float: left;">
            <span style="color:white; overflow:hidden;text-overflow:ellipsis; white-space:nowrap; width: 150px; ">{{PlatformCurrent.cPlatformName}}
            </span>
            <a-icon style="color:white" type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item @click="handleplatform(item)" v-for="item in PlatformList" style="width: 300px;    display: block;   ">
              <a>{{item.cPlatformName}}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>



      </div>

      <div class="adp-scene-all-choose">
        <div class="adp-scene-choose" @click="selectScene(item)" v-for="item in SceneList"><span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding: 0 3px"
            :title="item.cSceneName">{{item.cSceneName}}</span></div>

      </div>

      <div class="adp-scene-content-box">

        <div v-for="item in propertiesR" class="adp-scene-content-single">
          <div class="adp-scene-content-num">{{item.dataValue}}</div>
          <div>{{item.name}}</div>
        </div>

      </div>
    </div>

    <!--    图表模块-->
    <div class="adp-tb-all-box">
      <img src="../../img/dpsj/tbwk.png" alt="" class="adp-mod-bg-img">

      <div class="adp-tb-bing-box2" ref="chart" id="chart">

      </div>
    </div>


  </div>
</template>

<script>
  import {
    _getDevicePropDataTop
  } from '@/common/request'
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  import {
    videoPlayer
  } from 'vue-video-player'
  import 'videojs-flash'
  const Echarts = require('echarts/lib/echarts')
  require('echarts/lib/chart/bar')
  require('echarts/lib/chart/bar')
  require('echarts/lib/chart/pie')
  require('echarts/lib/component/legend')
  require('echarts/lib/component/tooltip')

  export default {
    components: {
      videoPlayer
    },
    data() {
      return {
        // 全屏判断
        n: 0,
        paramas: {
          sceneId: '',
          cEntID: ''
        },
        weatherToday: {
          actor: {
            mr: "",
            ms: "",
            sr: "",
            ss: ""
          },
          cond: {
            code_d: "",
            code_n: "",
            txt_d: "11",
            txt_n: ""
          },
          cloud: "",
          date: "",
          hum: "",
          pcpn: "",
          pop: "",
          pres: "",
          tmp: {
            max: "",
            min: ""
          },
          uv: "",
          vis: "",
          wind: {
            deg: "",
            dir: "",
            sc: "",
            spd: ""
          }
        },
        weatherOtherDay: [{
          cond: {
            code_d: "",
            code_n: "",
            txt_d: "11",
            txt_n: ""
          },
          cloud: "",
          date: "",
          hum: "",
          pcpn: "",
          pop: "",
          pres: "",
          tmp: {
            max: "",
            min: ""
          },
          uv: "",
          vis: "",
          wind: {
            deg: "",
            dir: "",
            sc: "",
            spd: ""
          }
        }],
        iconSrc1: '../../../static/weatherIcon/dy.png',
        EnterPrise: {},
        PlatformList: [],
        SceneList: [],
        SCeneCurrent: {
          ID: "",
          cSceneName: ""
        },
        PlatformCurrent: {
          ID: "",
          cPlatformName: ""
        },
        videodata: {
          cDeviceAsName: '',
          cVideoUrl: ''
        },
        cEntID: '',
        productKeys: [],
        propertiesR: [],
        DefaultScene: {
          cSceneName: ''
        },
        timer: '',
        videoOptions: {
          playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: true, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          techOrder: ['flash', 'html5'], // 兼容顺序
          sources: [{ // 流配置，数组形式，会根据兼容顺序自动切换
            type: 'rtmp/hls',
            src: ''
          }],
          poster: "", //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            ProcessBar: false,
            progressControl: false,
            autoDisable: true,
            fullscreenToggle: true //全屏按钮
          }
        }
      }
    },
    mounted() {
      const that = this
      this.EnterPrise = this.$store.getters.User.enterprise;
      that.paramas.sceneId = that.$store.getters.SCene.ID
      that.paramas.cEntID = that.$store.getters.User.enterprise.ID
      this.EchartList()
      this.EchartList1()
      this.getsceneList();

      this.timer = setInterval(this.getDevice, 10000);

      this.weatherList();
      this.getvideourl();
      this.handlePageList();
      this.handleSceneList();
    },
    methods: {
      async handlePageList() {
        let that = this;
        let param = {
          cEntID: that.$store.getters.User.enterprise.ID,
          userID:that.$store.getters.User.ID,
          cSystemCode: '节水灌溉'
        };
        let res = await that.$http.post('EntPlatformInfo/EnterPlatIList', param)
        //console.log('aaa', res);
        if (res.data.code == "200" && res.data.obj.list.length > 0) {
          that.PlatformList = res.data.obj.list;
          that.PlatformCurrent = that.PlatformList[0];

          that.$store.commit('setPlatForm', that.PlatformList[0]);
          that.handleSceneList();
        } else {
          that.$store.commit('setPlatForm', null);
          that.$message.error(res.message)

        }
        console.log(that.$store.getters.PlatForm)
        console.log(that.PlatformCurrent)

      },
      async handleSceneList() {
        let that = this;
        let param = {
          cPlatformID: that.PlatformCurrent.ID,
          cSystemCode: '节水灌溉'
        };
        let res = await that.$http.post('EntSceneInfo/List', param)

        if (res.data.code == "200") {

          if (res.data.obj.list && res.data.obj.list.length > 0) {
            that.SceneList = res.data.obj.list;
            that.SCeneCurrent = that.SceneList[0];
            that.$store.commit('setScene', that.SceneList[0]);


          } else {
            that.SceneList = [];
            that.SCeneCurrent = {
              ID: "",
              cSceneName: ""
            };

          }
        } else {
          that.$message.error(res.message)

        }
        that.handlescene(that.SCeneCurrent)
      },
      // 以下三个是全屏
      getFullCreeen() {
        this.n++;
        this.n % 2 == 0 ?
          this.outFullCreeen(document) : this.inFullCreeen(document.documentElement)
      },
      async EchartList() {
        const that = this

        const res = await that.$http.post('EntSeedingTask/IRRGetEChartNumOne', that.paramas)

        if (res.data.code == '200') {
          that.generateEChartsOne(res.data.obj.list)
        } else {
          that.$message.error(res.message)
        }
        that.generateEChartsOne(that.EchartNumOne)
      },
      async EchartList1() {
        const that = this

        const res = await that.$http.post('EntSeedingTask/IRRGetEChartNumTwo', that.paramas)

        if (res.data.code == '200') {
          that.generateEChartsTwo(res.data.obj.list)
        } else {
          that.$message.error(res.message)
        }

      },
      generateEChartsOne(EchartList) {
        setTimeout(function() {
          let NameList = [];
          let ValueList = []
          EchartList.forEach(function(element) {
            NameList.push(element.name)
            ValueList.push(element.value)
          })
          const that = this
          // 2.初始化
          // this.chart = Echarts.init(this.$refs.chart)
          this.chart = Echarts.init(document.getElementById('chart'))
          // 3.配置数据
          const option = {
            color: ['#00F0FF', '#FF9600'],
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '2%',
              top: '6%',
              right: '2%',
              bottom: '2%',
              containLabel: true
            },
            xAxis: {
              axisLabel: {
                color: '#ffffff' // 刻度线标签颜色
              },
              type: 'category',
              barWidth: 1,
              data: NameList

            },
            series: [{
                name: '灌水定额',
                type: 'bar',
                barWidth: 15, // 调节柱状图 柱宽度
                data: ValueList
              }
              // ,{
              //   name: '2012年',
              //   type: 'bar',
              //   barWidth: 15, // 调节柱状图 柱宽度
              //   data: [1300, 1000, 600]
              // }
            ],
            yAxis: {
              axisLabel: {
                color: '#ffffff' // 刻度线标签颜色
              },
              type: 'value'
            }
          }

          // 4.传入数据
          this.chart.setOption(option)
        }, 2000)
      },
      generateEChartsTwo(EchartList) {
        setTimeout(function() {
          // 2.初始化
          // this.chart = Echarts.init(this.$refs.chartTwo)
          this.chart = Echarts.init(document.getElementById('chartTwo'))
          // 3.配置数据
          const option = {
            color: ['#00F0FF', '#0CB32E', '#FF9600'],

            series: [{
              name: '交费',
              type: 'pie',
              labelLine: {
                show: true, // 数据标签引导线
                length: 20,
                lineStyle: {
                  width: 2,
                  type: 'solid'
                }
              },
              label: {
                normal: {
                  textStyle: {
                    color: '#ffffff' // 改变标示文字的颜色
                  }
                }
              },
              radius: '60%',
              // roseType: 'angle',
              data: EchartList
            }]
          }

          // 4.传入数据
          this.chart.setOption(option)
        }, 2000)
      },
      inFullCreeen(element) {
        let el = element;
        let rfs = el.requestFullScreen || el.webkitRequestFullScreen ||
          el.mozRequestFullScreen || el.msRequestFullScreen;
        if (typeof rfs != "undefined" && rfs) {
          rfs.call(el);
        } else if (typeof window.ActiveXObject != "undefined") {
          let wscript = new ActiveXObject("WScript.Shell");
          if (wscript != null) {
            wscript.SendKeys("{F11}");
          }
        }
      },
      outFullCreeen(element) {
        let el = element;
        let cfs = el.cancelFullScreen || el.webkitCancelFullScreen ||
          el.mozCancelFullScreen || el.exitFullScreen;
        if (typeof cfs != "undefined" && cfs) {
          cfs.call(el);
        } else if (typeof window.ActiveXObject != "undefined") {
          let wscript = new ActiveXObject("WScript.Shell");
          if (wscript != null) {
            wscript.SendKeys("{F11}");
          }
        }
      },


      // 返回上一页
      adpGoBack() {
        if (this.n % 2 !== 0) {
          this.getFullCreeen()
        }
        this.$router.go(-1)

      },

      async selectScene(scene) {
        this.DefaultScene = scene;
        this.getDevice();
      },
      async getDevice() {
        let that = this;
        that.propertiesR = [];


        let devicesRes = await this.$http.post('WLWDevice/List', {
          cSystemCode: '节水灌溉'
        });
        console.log('devicesRes', devicesRes);
        let devices = devicesRes.data.obj.list;

        //    let devices=that.$store.getters.Devices.filter(s=>s.cSceneID==that.DefaultScene.ID&&s.cEntID==that.EnterPrise.ID)
        console.log('.$store.getters.Devices', that.$store.getters.Devices);
        console.log('that.DefaultScene.ID', that.DefaultScene.ID);
        console.log('that.EnterPrise.ID', that.EnterPrise.ID);
        console.log('devices', devices);
        that.productKeys = devices.map(s => s.ProductKey);
        that.productKeys = [...new Set(that.productKeys)];

        that.getRDeviceDetial();

      },
      async getRDeviceDetial() {
        let that = this;
        console.log('that.$store.getters.ThingModels', that.$store.getters.ThingModels);
        var ThingModels = that.$store.getters.ThingModels.filter(x => that.productKeys.includes(x.productKey))
        if (ThingModels != null && ThingModels.length > 0) {
          ThingModels.filter((ele, index) => {
            that.propertiesR = that.propertiesR.concat(ele.propertiesR)
          })
          if (that.propertiesR && that.propertiesR.length > 6) {
            that.propertiesR = that.propertiesR.splice(0, 6)
          }
        } else {
          that.propertiesR = [];
        }
        var key = '';
        that.productKeys.map((ele, index) => {
          key += (ele + ',');
        })
        if (key) {
          key = key.substr(0, key.length - 1);
        }
        var data = await _getDevicePropDataTop(this, {
          productkey: key,
          devicename: ''
        })

        if (data.code == "200" && data.obj.list.length > 0) {

          var dataItems = {};
          data.obj.list.forEach((ele, index) => {
            for (let i in ele.dataItems) {

              that.$set(dataItems, i, ele.dataItems[i])
            }
          })
          that.propertiesR.forEach(element => {
            if (dataItems[element.identifier] != null) {
              console.log('dataItems[element.identifier].value', dataItems[element.identifier].value);
              var value = that.utils.formatPropData(element, dataItems[element.identifier].value)
              that.$set(element, "dataValue", value)
            } else {
              that.$set(element, "dataValue", '')
            }
          })

        }

      },
      async getvideourl() {
        let that = this;
        let param = null;
        let res = await that.$http.post('HkCamera/FindByAddressType?address=数据展示&cEntID=' + that.EnterPrise.ID, param)

        console.log('that.videodata.cVideoFlashUrl', res);
        if (res.data.code == "200") {
          if (res.data.obj.data) {
            that.videodata = res.data.obj.data;
            console.log('that.videodata.cVideoFlashUrl', that.videodata.cVideoFlashUrl);
            that.videoOptions.sources = [{ // 流配置，数组形式，会根据兼容顺序自动切换
              type: 'rtmp/hls',
              src: that.videodata.cVideoFlashUrl
            }]
          }

        } else {
          that.$message.error(res.message)

        }
      },
      //切换场地
      handleplatform(obj) {
        this.propertiesR = [];
        this.$bus.$emit('platformchange', {
          id: obj.ID
        });
        this.PlatformCurrent = obj;
        this.handleSceneList();
      },
      handlescene(obj) {
        this.$bus.$emit('scenechange', {
          id: obj.ID
        });
        this.SCeneCurrent = obj;
      },
      async getsceneList() {
        let that = this;
        let param = null;
        let res = await that.$http.post('EntSceneInfo/List', {
          cSystemCode: '节水灌溉',
          cEntID: that.EnterPrise.ID,
          cSystemCode: '节水灌溉'
        })

        if (res.data.code == "200") {
          that.SceneList = res.data.obj.list;
          if (that.SceneList[0]) {
            that.DefaultScene = that.SceneList[0];
            that.getDevice();
          }

        } else {
          that.$message.error(res.message)

        }
      },

      async weatherList() {
        let that = this;
        let res = await that.$http.get('WLWDevice/GetWeather', {})
        if (res.data.code == "200") {
          // console.log(res.data.message)
          let weatherList = JSON.parse(res.data.message);
          let weatherList1 = weatherList.result.HeWeather5[0].daily_forecast;

          let newWeatherList = [];
          weatherList1.map((item, index) => {
            let imgSrc
            switch (item.cond.txt_d) {
              case "多云":
                imgSrc = require('../../img/dpsj/weatherIcon/dy.png')
                break;

              case "雷阵雨":
                imgSrc = require('../../img/dpsj/weatherIcon/leizhenyu.png')
                break;

              case "阴":
                imgSrc = require('../../img/dpsj/weatherIcon/yin.png')
                break;

              case "晴":
                imgSrc = require('../../img/dpsj/weatherIcon/qing.png')
                break;

              default:
                imgSrc = require('../../img/dpsj/weatherIcon/dy.png')
            }
            newWeatherList.push(
              Object.assign(item, {
                iconSrc: imgSrc
              })
            )
          });
          that.weatherToday = newWeatherList[0];
          that.weatherOtherDay = newWeatherList.slice(1, 4);

        } else {
          that.$message.error(res.message)

        }
      },


    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>
<style>
  .adp-tb-bing-box2 {
    position: absolute;
    top: 3%;
    left: 3%;
    width: 94%;
    height: 93%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .adp-ld-all-box2{
      position: absolute;
      top: 33%;
      left: 37%;
      width: 17%;
      /*height: 18%;*/
  }
  .adp-tb-all-box2{
      position: absolute;
      top: 33.7%;
      left: 34%;
      width: 24.9%;
      height: 34%;
  }
</style>
<style>
  @import "allDataPage.css";
</style>
